import { webCrypto } from '#web-crypto';
export const hkdfDeriveAesKey = (aesSecret, salt, hash, info) => webCrypto.subtle.deriveKey({
    name: 'HKDF',
    salt,
    hash,
    info,
}, aesSecret, { name: 'AES-KW', length: 256 }, false, ['wrapKey', 'unwrapKey']);
